import {
    Button,
    Form,
    Input,
    Modal,
    Popconfirm,
    Space,
    Table, Radio,
    Tabs,
    Tooltip,
    Pagination,
    Collapse, Drawer,
    Switch,
    Select, Spin
} from "antd";
import {
    DownloadOutlined, LeftOutlined, CloseCircleOutlined,
    QuestionCircleOutlined, RightOutlined, PrinterOutlined, SendOutlined,
    SearchOutlined,
    ShareAltOutlined,
    UsergroupAddOutlined, FilterOutlined
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import InformesView from "../../informes/informes.view";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {dataActions} from "../../../../_actions";
import {xcService} from "../../../../_services/xcService";
import variables from "../../../../_constants/variables";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import InviteUser from "./invite";
import ResponsesView from "./responses.view";
import moment from "moment";
import {Excel} from "antd-table-saveas-excel";


const {Panel} = Collapse;
const StudentsView = () => {
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedFormRowKeys, setSelectedFormRowKeys] = useState([]);
    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [currentUser, setCurrentUser] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableAllData, setTableAllData] = useState([]);
    const [sourceData, setSourceData] = useState([]);
    const [tableDataForm, setTableDataForm] = useState([]);
    const [actualPage, setActualPage] = useState(1)
    const userType = storage.getItem(variables.USER_TYPE);
    const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
    const [userProfile, setUserProfile] = useState();
    const [search, setSearch] = useState("");
    const [pageSize, setPageSize] = useState(50);
    const [offset, setOffset] = useState(1);
    const [pagging, setPagging] = useState();
    const [showFilters, setShowFilters] = useState(false);
    const [loadingEst, setLoadingEst] = useState(false);
    const [loading, setLoading] = useState(false);
    const [courses, setCourses] = useState([]);

    const [sortField, setSortField] = useState("");
    const [order, setOrder] = useState("");
    const [year, setYear] = useState("");

    const [course, setCourse] = useState("");
    const [group, setGroup] = useState("");
    const [open, setOpen] = useState(false);
    const [placement, setPlacement] = useState('right');
    const [valueOrder, setValueOrder] = useState(-1);

    const [groups, setGroups] = useState([
        {value: "A", label: "A"},
        {value: "B", label: "B"},
        {value: "C", label: "C"},
        {value: "D", label: "D"},
        {value: "E", label: "E"},
        {value: "F", label: "F"},
        {value: "G", label: "G"},
        {value: "H", label: "H"},
        {value: "I", label: "I"},
        {value: "J", label: "J"},
        {value: "K", label: "K"},
        {value: "L", label: "L"},
        {value: "M", label: "M"},
        {value: "N", label: "N"},
        {value: "O", label: "O"},
        {value: "P", label: "P"},
        {value: "Q", label: "Q"},
        {value: "R", label: "R"},
        {value: "S", label: "S"},
        {value: "T", label: "T"},
        {value: "U", label: "U"},
        {value: "V", label: "V"},
        {value: "W", label: "W"},
        {value: "X", label: "X"},
        {value: "Y", label: "Y"},
        {value: "Z", label: "Z"}
    ])

    const [ordersField, setOrdersField] = useState([
        {o: "DESC", f: "year", t: t("ordenayd")},
        {o: "ASC", f: "year", t: t("ordenaya")},
        {o: "DESC", f: "course_id", t: t("ordenaccursod")},
        {o: "ASC", f: "course_id", t: t("ordenaccursoa")},
        {o: "DESC", f: "group", t: t("ordenagroupd")},
        {o: "ASC", f: "group", t: t("ordenagroupa")},
        {o: "DESC", f: "center_id", t: t("ordenacentrod")},
        {o: "ASC", f: "center_id", t: t("ordenacentroa")}
    ]);

    const coursesData = useSelector((state) => state.dataReducer.coursesData);

    useEffect(() => {
        if (!coursesData) getCourses();
    }, []);

    const getCourses = () => {
        dispatch(dataActions.getCourses());
    };

    const removeFilters = () => {
        setCourse("");
        setGroup("")
        getStudents(pageSize, 1, search, "", "", "", "", "");
    }

    useEffect(() => {
        if (coursesData) setCourses(coursesData.map(it => {
            return {
                label: it.name,
                value: it.id
            }
        }));
    }, [coursesData]);


    const getAllStudents = (size, page, search) => {
        setLoading(true);
        const studentEndpoints = {
            'TUTOR': '/v1/tutor/auth/students?all=true',
            'COUNSELOR': '/v1/counselor/students?all=true',
            'CENTER': '/v1/center/students?all=true',
            'MASTER': '/v1/master/students?all=true'
        }
        xcService.getToken(studentEndpoints[userType])
            .then(({data}) => {

                let mData = data.data;
                if (data.data.data) {
                    mData = data.data.data;
                }

                return mData.map(({
                                      uid, name, surname, email, age, gender,
                                      centerCode,
                                      listNumber, info,
                                      group,
                                      course_id, centerName,
                                      year
                                  }) => {
                    return {
                        key: uid,
                        uid,
                        name: name + ' ' + surname,
                        uname: name,
                        usurname: surname,
                        email,
                        centre: centerCode,
                        centerName: centerName,
                        group,
                        sinfo: info ? t("tsi") : t("tno"),
                        listNumber,
                        age, gender,
                        course: coursesData.find(({id}) => id === course_id)?.name,
                        year: year + '/' + (year + 1)
                    }
                })
            })
            .then(data => {
                setLoading(false);
                setTableAllData(data);
            }).catch(err => {
            setLoading(false);
        })
    }

    const getStudents = (size, page, search, course, group, year = "", orderD = "", fieldS = "") => {
        setLoadingEst(true)

        const studentEndpoints = {
            'TUTOR': '/v1/tutor/auth/students?sortorder=' + orderD + '&sort=' + fieldS + '&limit=' + size + "&offset=" + page + "&search=" + search + "&course=" + course + "&group=" + group,
            'COUNSELOR': '/v1/counselor/students?sortorder=' + orderD + '&sort=' + fieldS + '&limit=' + size + "&offset=" + page + "&search=" + search + "&course=" + course + "&group=" + group,
            'CENTER': '/v1/center/students?sortorder=' + orderD + '&sort=' + fieldS + '&limit=' + size + "&offset=" + page + "&search=" + search + "&course=" + course + "&group=" + group,
            'MASTER': '/v1/master/students?sortorder=' + orderD + '&sort=' + fieldS + '&limit=' + size + "&offset=" + page + "&search=" + search + "&course=" + course + "&group=" + group
        }
        xcService.getToken(studentEndpoints[userType])
            .then(({data}) => {
                setTableData(null);
                setSourceData(null);
                setLoadingEst(false)
                let mData = data.data;
                if (data.data.data) {
                    mData = data.data.data;
                    setPagging(data.data.paging)
                }
                return mData.map(({
                                      uid, name, surname, email, age, gender,
                                      centerCode,
                                      listNumber,
                                      group, info,
                                      course_id, centerName,
                                      year
                                  }) => {
                    return {
                        key: uid,
                        uid,
                        name: name + ' ' + surname,
                        uname: name,
                        usurname: surname,
                        email,
                        sinfo: info ? t("tsi") : t("tno"),
                        centre: centerCode,
                        centerName: centerName,
                        group,
                        listNumber,
                        age, gender,
                        course: coursesData.find(({id}) => id === course_id)?.name,
                        year: year + '/' + (year + 1)
                    }
                })
            })
            .then(data => {
                setShowFilters(false);
                setTableData(data);
                setSourceData(data);
                setLoadingEst(false)
            })
    }


    function onChange(pagination, filters, sorter, extra) {


        setOffset(pagination)
        if (filters !== pageSize) {
            setPageSize(filters)
            getStudents(filters, pagination, search, course, group, year, order, sortField);
        } else {
            getStudents(pageSize, pagination, search, course, group, year, order, sortField);
        }


    }

    function changeSize(current, size) {
        setPageSize(size);
        // getCentros(size,current);
    }

    useEffect(() => {
        if (coursesData) {
            getStudents(pageSize, 1, search, course, group, year, order, sortField)
            //   getAllStudents()
            if (userType !== 'MASTER')
                xcService.getToken(userType === 'CENTER' ? '/v1/center/me' : '/v1/tutor/me/center').then(({data}) => {
                    setUserProfile(data.data)
                });
        }
    }, [coursesData])

    function onlyUnique(value, index, self) {
        return self?.indexOf(value) === index;
    }


    const headersCsv = [
        {title: t("identificador"), key: "identifier", dataIndex: "identifier"},
        {title: t("tutores.informes.tableename"), key: "name", dataIndex: "name"},
        {title: t("tutores.informes.tableemail"), key: "email", dataIndex: "email"},
        {title: t("registro.edad"), key: "age", dataIndex: "age"},
        {title: t("registro.genero"), key: "gender", dataIndex: "gender"},
        {title: t("tutores.informes.tablecenter"), key: "centerName", dataIndex: "centerName"},
        {title: t("filtro.codigo"), key: "centre", dataIndex: "centre"},
        {title: t("getinfo"), key: "sinfo", dataIndex: "sinfo"},
        {title: t("tutores.informes.tableyear"), key: "year", dataIndex: "year"},
        {title: t("tutores.informes.tablecourse"), key: "course", dataIndex: "course"},
        {title: t("tutores.informes.tablegroup"), key: "group", dataIndex: "group"},
        {title: t("tutores.informes.tablelist"), key: "listNumber", dataIndex: "listNumber"},
        {title: t("rinfo"), key: "info", dataIndex: "info"},
        {title: t("access"), key: "access", dataIndex: "access"},
        {title: t("q1"), key: "quest1", dataIndex: "quest1"},
        {title: t("q2"), key: "quest2", dataIndex: "quest2"},
        {title: t("q3"), key: "quest3", dataIndex: "quest3"},
        {title: t("avatar"), key: "avatarchanged", dataIndex: "avatarchanged"}
    ];

    const exportXLS = () => {


        const studentEndpoints = {
            'TUTOR': '/v1/tutor/downExcel',
            'COUNSELOR': '/v1/counselor/downExcel',
            'CENTER': '/v1/center/downExcel',
            'MASTER': '/v1/master/downExcel'
        }
        xcService.getToken(studentEndpoints[userType])
            .then(({data}) => {

            })


        const excel = new Excel();

        excel

            .addSheet("students")
            .addColumns(headersCsv)
            .addDataSource(tableAllData, {
                str2Percent: true
            })
            .saveAs("studentsExport" + moment().format(("YYYYMMDD")) + ".xlsx");
    }

    const columns = [
        {
            title: t("tutores.informes.tableselect"),
            dataIndex: 'name',
            render: (text) => <p className={"text-data"}>{text}</p>
        },
        {
            title: t("tutores.informes.tableemail"),
            dataIndex: 'email',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>
        },
        {
            title: t("tutores.informes.tablecenter"),
            dataIndex: 'centre',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>
        },
        {
            title: t("tutores.informes.tableyear"),
            dataIndex: 'year',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>
        },
        {
            title: t("tutores.informes.tablecourse"),
            dataIndex: 'course',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>


        },
        {
            title: t("tutores.informes.tablegroup"),
            dataIndex: 'group',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>


        },
        {
            title: t("getinfo"),
            dataIndex: 'sinfo',
            render: (text) => {
                return <p className={"text-data"}>{text}</p>
            }
        },
        {
            title: t("tutores.informes.tablelist"),
            dataIndex: 'listNumber',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>
        },
        {
            title: ['MASTER', 'CENTER'].includes(userType) ? t("tutores.informes.tabledelete") : t("tutores.informes.tableview"),
            key: 'view',
            render: (_, record) => (
                <Space size="middle">
                    <div className={"text-show-data"}>
                        {['MASTER', 'CENTER'].includes(userType) ?
                            <Popconfirm onConfirm={() => deleteUser(record.uid)}
                                        title={t("seguroEliminarS")}
                                        okText={t("yes")}
                                        cancelText="No"
                            ><a href={"#"}>
                                {t("tutores.informes.tabledelete")} <RightOutlined/>
                            </a></Popconfirm>

                            :
                            <>
                                <a onClick={() => setCurrentUser(record)}>{t("tutores.informes.view")} <RightOutlined/></a>
                            </>
                        }

                    </div>
                </Space>
            ),
        },
    ];


    const columnsTable = [

        {
            title: t("tutores.informes.tableemail"),
            dataIndex: 'email',
            sortable: true,
        },
        {
            title: t("tutores.informes.tablecenter"),
            dataIndex: 'centre',
            sortable: true,
        },
        {
            title: t("tutores.informes.tableyear"),
            dataIndex: 'year',
            sortable: true,
        },
        {
            title: t("tutores.informes.tablecourse"),
            dataIndex: 'course',
            sortable: true,


        },
        {
            title: t("tutores.informes.tablegroup"),
            dataIndex: 'group', sortable: true,

        },
        {
            title: t("getinfo"),
            dataIndex: 'sinfo',
            sortable: true,

        },
        {
            title: t("tutores.informes.tablelist"),
            dataIndex: 'listNumber',
            sortable: true,

        }
    ];

    useEffect(() => {
        if (!currentUser) return;
        setTableDataForm([
            {
                'key': 0,
                'name': 'Intereses Vocacionales',
                'year': '20/21',
                'course': '3ºESO'
            }
        ])
    }, [currentUser])

    const onSearch = (target) => {


        setSearch(target);
        getStudents(pageSize, 1, target, course, group, year, order, sortField);


    }

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const onSelectFormChange = newSelectedRowKeys => {
        setSelectedFormRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const rowSelectionForm = {
        selectedFormRowKeys,
        onChange: onSelectFormChange,
    };


    const deleteUser = (id) => {
        xcService.deleteToken(`/v1/${userType === "MASTER" ? 'master' : 'tutor'}/auth/delete/student/${id}`).then(data => {
            getStudents(pageSize, 1, search, course, group, year, order, sortField)
            setCurrentUser(null)

        })
    }

    const onChangePage = (pageNumber, filters, sorter) => {

        setGroup(filters.group ? filters.group[0] : "")
        setCourse(filters.course ? filters.course[0] : "")
        setActualPage(pageNumber.current);
        localStorage.setItem("STUDENTPAGE", 1);
    };

    const goBack = () => {
        let mPage = 1;
        if (localStorage.getItem("STUDENTPAGE")) {
            mPage = +localStorage.getItem("STUDENTPAGE")
        }
        setActualPage(mPage);
        setCurrentUser(null)

    }

    const desvincula = (id) => {
        xcService.putToken(`/v1/${userType === "MASTER" ? 'master' : userType === "CENTER" ? 'center' : 'tutor'}/auth/student/unvalidate/${id}`).then(data => {
            setCurrentUser(null)
            getStudents(pageSize, 1, search, course, group, year, order, sortField)

        })
    }


    const delFilters = () => {
        setSortField("");
        setOrder("")
        setYear("")
        setGroup("")
        setCourse("");
        getStudents(pageSize, 1, "", "", "", "", "", "");
        setOpen(false)

    }

    const onChangeCourse = (e) => {
        if (!e) {

            setCourse("")
        } else {
            setCourse(e.target.value)
        }
    };

    const onChangeGroup = (value) => {

        if (!value) {

            setGroup("")
        } else {
            setGroup(value)
        }

    }
    const handleSortingChange = (accessor) => {

    }

    const applyFilters = () => {
        getStudents(pageSize, 1, search, course, group, year, order, sortField);
        setOpen(false)
    }


    const onClose = () => {
        setOpen(false);
    };
    const onChangeOrder = (e) => {
        setValueOrder(e.target.value);

        setOrder(ordersField[e.target.value].o);

        setSortField(ordersField[e.target.value].f);
    };
    return (
        <>

            {showFilters &&
                <Modal className={"modalName modal-question modal-question--xs modal-custom--xs"}
                       title={t("filtros")}
                       centered
                       visible={showFilters}
                       okText={t("showres")}
                       onOk={() => applyFilters()}
                       onCancel={() => setShowFilters(false)}
                >

                    <h5>{t("login.course")}</h5>
                    <Select
                        value={course}
                        style={{width: "90%"}}

                        allowClear
                        placeholder={t("login.course")}
                        optionFilterProp="children"
                        onChange={onChangeCourse}

                        filterOption={(input, option) => {


                            return (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        }
                        options={courses}
                    />
                    <h5>{t("login.group")}</h5>
                    <Select
                        value={group}
                        style={{width: "90%"}}

                        allowClear
                        placeholder={t("login.group")}
                        optionFilterProp="children"
                        onChange={onChangeGroup}

                        filterOption={(input, option) => {


                            return (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        }
                        options={groups}
                    />


                </Modal>
            }
            {showDeleteUserModal &&
                <Modal>
                    <p>{t("apuntode")}{showDeleteUserModal}. {t("seguro")}</p>
                </Modal>
            }
            {showInviteUserModal &&
                <InviteUser t={t} type={"student"}
                            link={"/auth/register"}
                            userProfile={userProfile} showInviteUserModal={showInviteUserModal}
                            setShowInviteUserModal={setShowInviteUserModal}/>
            }
            {!currentUser && <div>
                <Drawer
                    title={t("filtros")}
                    placement={placement}
                    width={580}
                    onClose={onClose}
                    open={open}
                    extra={
                        <Space>
                            <Button onClick={delFilters}>{t("borrarfiltros")}</Button>
                            <Button type="primary" onClick={applyFilters}>
                                {t("aplicarfiltros")}
                            </Button>
                        </Space>
                    }
                >
                    <h5>{t("login.course")}</h5>
                    <Radio.Group onChange={onChangeCourse} value={course} optionType="button" className={"filterCourse"}>
                        {courses.map((l, idx) => {
                            return <Radio key={l.value + idx} value={l.value}>{l.label}</Radio>
                        })}
                    </Radio.Group>

                    <h5>{t("login.group")}</h5>
                    <Select
                        value={group}
                        style={{width: "50%"}}

                        allowClear
                        placeholder={t("login.group")}
                        optionFilterProp="children"
                        onChange={onChangeGroup}

                        filterOption={(input, option) => {


                            return (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        }
                        options={groups}
                    />
                    <p></p>
                    <h5>{t("ordenapor")}</h5>
                    <Radio.Group onChange={onChangeOrder} value={valueOrder} optionType="button">
                        <Space direction="vertical">
                            <Space direction="horizontal">
                                <Radio value={0}>{ordersField[0].t}</Radio>
                                <Radio value={1}>{ordersField[1].t}</Radio>
                            </Space>
                            <Space direction="horizontal">
                                <Radio value={2}>{ordersField[2].t}</Radio>
                                <Radio value={3}>{ordersField[3].t}</Radio>
                            </Space>
                            <Space direction="horizontal">
                                <Radio value={4}>{ordersField[4].t}</Radio>
                                <Radio value={5}>{ordersField[5].t}</Radio>
                            </Space>
                            {userType === "MASTER" &&
                                <Space direction="horizontal">
                                    <Radio value={6}>{ordersField[6].t}</Radio>
                                    <Radio value={7}>{ordersField[7].t}</Radio>
                                </Space>
                            }
                        </Space>
                    </Radio.Group>

                </Drawer>

                <div className={"informes-header"}>
                    <div className={"informes-header__top"}>
                        <h1 className={"is-first"}>{t("tutores.informes.title")}</h1>
                        <Button className={"btnWhiteBlue"}
                                onClick={() => setShowInviteUserModal(true)}><UsergroupAddOutlined/>{t("alumnos.familyButton")}
                        </Button>
                    </div>
                    {userType === 'CENTER' &&
                        <>
                            <p>{t("lusers.centeralumno")}</p>
                        </>
                    }
                    {userType === 'COUNSELOR' &&
                        <>
                            <p>{t("lusers.orientaalumno")}</p>
                            <p>{t("lusers.orientasubalumno")}</p>
                        </>
                    }
                    {userType === 'TUTOR' &&
                        <>
                            <p>{t("lusers.tutoralumno")}</p>
                            <p>{t("lusers.tutorsubalumno")}</p>
                        </>
                    }
                    {userType === 'MASTER' &&
                        <p>{t("tutores.informes.substudentsadmin")}</p>
                    }
                    <div className={"informes-header__bottom"}>
                        <div className={"informes-header__bottom-left"}>
                            <Search
                                placeholder={t("tutores.informes.search")}
                                allowClear
                                enterButton={<SearchOutlined/>}
                                size="large"
                                onSearch={onSearch}
                            />
                        </div>
                        <div className={"informes-header__bottom-right"}>
                            <Button onClick={() => setOpen(true)}
                                    className={"btnWhiteBlue"}><FilterOutlined/>{t("filtros")}
                            </Button>


                            {

                                (course !== "" || (group !== "")) &&
                                <Button onClick={() => removeFilters()}
                                        className={"btnWhiteBlue"}><CloseCircleOutlined/>{t("borrarfiltros")}
                                </Button>

                            }
                            {1 === 2 && userType === "MASTER" &&
                                <Button

                                    loading={tableAllData.length === 0}
                                    onClick={exportXLS}

                                    className={"btnWhiteBlue"}><DownloadOutlined/>{t("tutores.informes.downloadButton")}
                                </Button>
                            }

                            {1 === 2 &&
                                <Button className={"btnWhiteBlue"}><PrinterOutlined/>{t("tutores.informes.printButton")}
                                </Button>
                            }

                        </div>
                    </div>
                </div>
                <div className={"report-table"}>

                    <Table onChange={onChangePage} rowKey={"email"}
                           loading={loadingEst}
                           pagination={pagging ?
                               {
                                   defaultPageSize: pageSize,
                                   showSizeChanger: true,
                                   onShowSizeChange: changeSize,
                                   pageSize: pageSize,
                                   current: offset,
                                   total: pagging.total,
                                   onChange: onChange,
                                   position: ['bottomCenter']
                               } : false
                           } rowSelection={rowSelection} columns={columns}
                           dataSource={tableData}/>


                </div>
            </div>}
            {currentUser && <div>
                <div className={"informes-header"}>
                    <a className={"informes-header__back"} onClick={() => goBack()}><LeftOutlined/> {t("backtolist")}
                    </a>
                    <div className={"informes-header__top"}>
                        <h1>{t("tutores.alumno.title")}</h1>
                    </div>
                    <div className={"cardStudent cardStudent--max-width"}>
                        {/* ToDo : Revisar carga de datos */}
                        <div className={"itemCard itemCardHeader"}>{t("informes.card.title")}</div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tableename")}:</div>
                            <div className={"itemCardRight"}>{currentUser.uname}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tablesurename")}:</div>
                            <div className={"itemCardRight"}>{currentUser.usurname}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tableemail")}:</div>
                            <div className={"itemCardRight"}>{currentUser.email}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tablecenter")}:</div>
                            <div className={"itemCardRight"}>{currentUser.centerName.replaceAll("&quot;", "")}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tablecode")}:</div>
                            <div className={"itemCardRight"}>{currentUser.centre}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tableyear")}:</div>
                            <div className={"itemCardRight"}>{currentUser.year}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tablecourse")}:</div>
                            <div className={"itemCardRight"}>{currentUser.course}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tablegroup")}:</div>
                            <div className={"itemCardRight"}>{currentUser.group}</div>
                        </div>
                        <div className={"itemCard"}>
                            <div className={"itemCardLeft"}>{t("tutores.informes.tablelist")}:</div>
                            <div className={"itemCardRight"}>{currentUser.listNumber}</div>
                        </div>
                    </div>

                    <Popconfirm onConfirm={() => desvincula(currentUser.uid)}
                                title={t("segurodesvinculara")}
                                okText={t("yes")}
                                cancelText="No"
                    >
                        <Button className={"btnWhiteBlue"}><UsergroupAddOutlined/>{t("tutores.alumno.unlink")}</Button></Popconfirm>

                </div>
                <div className={"informes-content"}>
                    <p className={"fw-strong"}>{t("tutores.alumno.subtitle")}</p>
                    {1 === 2 && <div className={"container--informes--buttons"}>
                        <Button className={"btnWhiteBlue"}><DownloadOutlined/>{t("tutores.informes.downloadButton")}
                        </Button>
                        <Button className={"btnWhiteBlue"}><DownloadOutlined/>{t("tutores.informes.printButton")}
                        </Button>
                        <Button className={"btnWhiteBlue"}><SendOutlined/>{t("tutores.informes.shareButton")}
                        </Button>
                    </div>}
                    <Tabs
                        defaultActiveKey="1"

                        items={[
                            {
                                label: t("menu.informes"),
                                key: '1',
                                children: <InformesView student={false} user={currentUser}/>,
                            }
                            , {
                                label: t("menu.respuestas"),
                                key: '2',
                                children: <ResponsesView user={currentUser}/>,
                            }

                        ]}
                    />
                </div>
            </div>}
        </>
    )
}

export default StudentsView;
